import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { CardBody, Dialog, DialogBody, DialogHeader, ListItem } from "@material-tailwind/react";
import { modelContext } from './ModalProvider'
import { Button, Card } from 'flowbite-react';
import DeleteAlert from '../../../components/alert-box/DeleteAlert'
import { MdDeleteForever } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from '../../../_store/notifications.slice';

const NotificationsView = (props) => {

    const dispatch = useDispatch();

    const notificaitonsState = useSelector(state => state.notifications)
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [model, setModel] = useContext(modelContext);

    const docViewrDefaultState = {
        show: false,
        docUrl: null
    }
    const [selectedNotificationId, setSelectedNotificationId] = useState(null)
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [docViewer, setDocViewer] = useState(docViewrDefaultState);

    // const fetcNotifications = ()=>{
    //     const URL = process.env.REACT_APP_API_URL + "/auth/notifications"
    //     const body = {
    //         "action": "fetch"
    //     }

    //     axios.post(URL, body)
    //         .then((resp) => {
    //             const data = resp.data
    //             if (data) {
    //                 setNotifications(data)
    //             }
    //         })
    //         .catch((e) => {
    //             console.error("Error fetching notifications:", e);
    //             setNotifications([]);  // fallback in case of error
    //         })
    //         // .finally(() => {
    //         //     setLoading(false); // stop loading regardless of success or error
    //         // });
    // }
    useEffect(() => {
        //fetcNotifications();
        const body = {
            "action": "fetch"
        }
        dispatch(notificationActions.getNotifications(body))

    }, [])

    const initDeleteAction = (id) => {
        setSelectedNotificationId(id)
        setOpenDeleteModal(true)
    }

    useEffect(() => {
        console.log(selectedNotificationId);
    }, selectedNotificationId)
    const toogleDocViewer = (modalState, docUrl) => {
        setDocViewer({
            ...docViewer,
            show: modalState,
            docUrl: docUrl
        })
    }

    console.log(notificaitonsState);

    // const token = localStorage.getItem('authToken'); // or wherever your token is stored

    // const deleteNotification = async () => {
    //     if (selectedNotificationId) {
    //         const URL = process.env.REACT_APP_API_URL + "/auth/notifications";
    //         const body = {
    //             action: "delete",
    //             notificationId: selectedNotificationId
    //         };

    //         try {
    //             const response = await axios.post(URL, body, {
    //                 headers: {
    //                     'Authorization': `Bearer ${token}`
    //                 }
    //             });

    //             if (response.data && response.data.status === "success") {
    //                 // Remove the notification from the state
    //                 setNotifications(prev => prev.filter(n => n.id !== selectedNotificationId));
    //                 setSelectedNotificationId(null);
    //                 setOpenDeleteModal(false);
    //             } else {
    //                 alert("Failed to delete notification.");
    //             }
    //         } catch (error) {
    //             console.error("Error deleting notification:", error);
    //             alert("Something went wrong while deleting.");
    //         }
    //     }
    // };

    // const deleteNotification = async () => {
    //     if (!selectedNotificationId) return;

    //     const storedUser = localStorage.getItem('user');
    //     let token = null;

    //     try {
    //         const parsedUser = JSON.parse(storedUser);
    //         token = parsedUser?.access_token;
    //     } catch (error) {
    //         console.error("Failed to parse user from localStorage:", error);
    //         alert("Authentication error. Please login again.");
    //         return;
    //     }

    //     if (!token) {
    //         alert("You are not authenticated. Please login again.");
    //         return;
    //     }

    //     const URL = process.env.REACT_APP_API_URL + "/auth/notifications";
    //     const body = {
    //         notificationId: selectedNotificationId
    //     };

    //     try {
    //         const response = await axios.delete(URL,body, {   
    //             headers: {
    //                 'Authorization': `Bearer ${token}`
    //             }
    //         });

    //         if (response.data && response.data.status === "success") {
    //             setNotifications(prev => prev.filter(n => n.id !== selectedNotificationId));
    //             setSelectedNotificationId(null);
    //             setOpenDeleteModal(false);
    //         } else {
    //             alert("Failed to delete notification.");
    //         }
    //     } catch (error) {
    //         console.error("Error deleting notification:", error);
    //         alert("Something went wrong while deleting.");
    //     }
    // };

    const deleteNotification = async () => {
        if (selectedNotificationId) {
            const body = {
                notificationId: selectedNotificationId
            }
            const resp = await dispatch(notificationActions.deleteNotification(body))
            if (resp.meta.requestStatus === 'fulfilled' || 200) {
                setSelectedNotificationId(null);
                //  fetcNotifications();

            }
        }
    }



    return <>
        <div className="lg:mx-auto" >
            <div className="mx-auto w-full">
                {/* {loading ? (
                    <Card className="w-full flex-row">
                        <CardBody className="w-full text-center m-20">
                            <h1 className="text-blue-500 font-semibold text-xl flex items-center gap-3">Loading notifications...
                                <span><svg className="animate-spin h-10 w-10 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-30" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                </svg></span>
                            </h1>
                        </CardBody>
                    </Card>
                ) : ( */}
                {notificaitonsState.notifications && notificaitonsState.notifications.length > 0 ? (
                    notificaitonsState.notifications.map((item) => (
                        <ListItem
                            key={item.id}
                            style={{ backgroundColor: 'white' }}
                            className="flex justify-between space-y-8 border-b px-2  mb-4"
                            onClick={() => setModel({ show: !model.show, type: 'content', title: item.subject, msg: item.msg })}
                        >
                            <div className="flex flex-col">
                                <div className="text-black text-md flex font-semibold my-1">
                                    <div>{item.subject}</div>
                                </div>
                                <div className="text-gray-600 text-sm whitespace-pre-line mb-6">
                                    {item.msg}
                                </div>
                                {item.eventLink && (
                                    <div className="mt-2">
                                        <p className="font-semibold text-gray-800">
                                            👇 CLICK HERE TO REGISTER 👇
                                        </p>
                                        <a
                                            href={item.eventLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline break-all px-4"
                                            onClick={(e) => e.stopPropagation()} // prevent modal open
                                        >
                                            {item.eventLink}
                                        </a>
                                    </div>
                                )}

                            </div>
                            <div className="col-span-2 flex items-center gap-2">
                                <Button
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent opening modal
                                        initDeleteAction(item.id);
                                    }}
                                    variant="text"
                                    color="red"
                                    style={{ border: 'none' }}
                                    className="flex items-center gap-2"
                                >
                                    <MdDeleteForever />
                                </Button>

                                {item.asset && item.asset.filePath && (
                                    <Button
                                        variant="text"
                                        className="flex items-center gap-2"
                                        onClick={(e) => {
                                            e.stopPropagation(); // Prevent opening modal
                                            toogleDocViewer(true, item.asset.filePath);
                                        }}
                                    >
                                        <div className="border-b-2 border-black">Learn More</div>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            className="h-4 w-4"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                                            />
                                        </svg>
                                    </Button>
                                )}
                            </div>
                        </ListItem>
                    ))

                ) : (
                    <Card className="w-full flex-row">
                        <CardBody className="w-full text-center m-20">
                            <h3>No Notifications available</h3>
                        </CardBody>
                    </Card>
                )
                }

                <DeleteAlert openModal={openDeleteModal} setOpenDeleteModal={setOpenDeleteModal}
                    msg="Are you sure you want to delete event ?"
                    confirmAction={() => deleteNotification()} />
                <Dialog open={docViewer.show} handler={() => toogleDocViewer(false, null)} size="lg" popup dismiss={{ enabled: false }}>
                    <DialogHeader>
                        <div className="flex flex-between py-4 px-6 w-full">
                            {/* <div className="text-xl font-semibold text-gray-900 dark:text-white"> 
                                <div> Event Infomration ! </div>
                            </div> */}
                            <button onClick={() => toogleDocViewer(false, null)} aria-label="Close" className="ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white" type="button">
                                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>
                            </button>
                        </div>
                    </DialogHeader>
                    <DialogBody className="h-[56rem] overflow-scroll w-[95%] m-auto">
                        <img className='lg:w-full' src={docViewer.docUrl} />
                    </DialogBody>
                </Dialog>

            </div>
        </div>
    </>
}

export default NotificationsView;